import { Injectable } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { Response } from '@shared/models/response.model';
import { AmbassadorPin, EventPin, ProjectPin } from '@shared/interfaces/pins.interface';

@Injectable({
    providedIn: 'root'
})
export class PinsService {
    constructor(private baseHttp: BaseHttpService) {
    }

    getProjectPins(): Observable<Response<ProjectPin[]>> {
        return this.baseHttp
            .get('/pins/project')
            .pipe(map((resp) => resp as Response<ProjectPin[]>));
    }

    getAmbassadorPins(): Observable<Response<AmbassadorPin[]>> {
        return this.baseHttp
            .get('/pins/ambassador')
            .pipe(map((resp) => resp as Response<AmbassadorPin[]>));
    }

    getEventPins(): Observable<Response<EventPin[]>> {
        return this.baseHttp
            .get('/pins/event')
            .pipe(map((resp) => resp as Response<EventPin[]>));
    }
}
